import { render, staticRenderFns } from "./sublimeSuccess.vue?vue&type=template&id=54a819ec&scoped=true"
import script from "./sublimeSuccess.vue?vue&type=script&lang=js"
export * from "./sublimeSuccess.vue?vue&type=script&lang=js"
import style0 from "./sublimeSuccess.vue?vue&type=style&index=0&id=54a819ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a819ec",
  null
  
)

export default component.exports